<div
  class="sidebar-wrapper"
  [ngClass]="{'over-header-and-footer': layoutConfiguration.sidebarOptions.sidebarOverHeaderAndFooter}"
>
  <div class="sidebar-holder">
    <app-sidebar-initial *ngIf="layoutConfiguration.sidebarOptions.sidebarType === 'initial'"></app-sidebar-initial>
    <app-sidebar-second *ngIf="layoutConfiguration.sidebarOptions.sidebarType === 'second'"></app-sidebar-second>
  </div>
  <div class="sidebar-backdrop"></div>
</div>